import React from 'react';
import { Button } from 'ra-ui-materialui';
import { Close as CloseIcon } from '@material-ui/icons';
import '../../styles.css';

export default ({
  dataProvider,
  resource,
  data,
  setSubmitting,
}) => {
  const handleClick = async () => {
    setSubmitting(true);
    dataProvider('CLOSE_ACCOUNT_ONE', resource, { userId: data.id }, {
      onSuccess: {
        notification: { body: 'Account Closed Successfully!', level: 'info' },
        callback: () => setSubmitting(false),
        refresh: true,
      },
      onError: {
        notification: { body: 'Account Could Not Be Closed!', level: 'warning' },
        callback: () => setSubmitting(false),
      },
    });
  };
  return (
    <Button
      variant="contained"
      label="Close Account"
      style={{ width: '100%', marginTop: 4 }}
      className="primaryButton userActionButton"
      onClick={handleClick}
    >
      <CloseIcon />
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/User/actions/actions/CloseAccountButton.jsx